import Link from "next/link"
import Image from "next/image"
import SocialMediaBar from "./SocialMediaBar"
import Ribbon from "public/assets/corner-ribbons.svg"

export default function Hero({}) {
  return (
    <header className="bg-charcoal-gradient">
      <div className="bg-logo bg-[500px_auto] py-10 px-5">
        <div className="max-w-screen-xl mx-auto">
          <div className="flex flex-col gap-5 md:flex-row md:items-center md:border-4 md:py-12 md:px-16 md:border-charcoal-dark md:bg-[rgba(7,7,7,0.45)] md:relative">
            <Ribbon className="hidden md:block md:absolute -top-11 -left-11" />
            <div className="mx-auto md:order-2 md:basis-1/3">
              <Link href="https://federalnewsnetwork.com" target="_blank">
                <Image
                  src="/assets/logo.webp"
                  className="z-10"
                  height="400"
                  width="400"
                  alt="FNN 25th Anniversary Logo"
                />
              </Link>
            </div>

            <div className="flex flex-col gap-5 md:basis-2/3">
              <div>
                <h1 className="text-center">
                  <div className="text-tertiary">25 TRANSFORMATIVE MOMENTS</div>
                  <div className="flex items-center">
                    <div className="h-2 border-t border-secondary border-b w-full"></div>
                    <div className="text-secondary font-light whitespace-nowrap mx-6">ACROSS 25 YEARS</div>
                    <div className="h-2 border-t border-secondary border-b w-full"></div>
                  </div>
                </h1>
              </div>
              <p className="text-gray-light">
                Over the last quarter-century, the federal government has undergone significant transformation — and the
                pace of change only continues to accelerate. Federal News Network has been there every step of the way,
                bringing you the stories that matter.{" "}
                <strong className="font-black">
                  To celebrate our 25th anniversary in 2025, we’ll be spotlighting 25 pivotal moments that reshaped the
                  way the government operates.
                </strong>{" "}
                Join us each week as we look back on these defining moments, their lasting impact today and how they
                continue to shape the future of government and its workforce tomorrow.
              </p>

              <SocialMediaBar type="secondary" />
            </div>
            <Ribbon className="hidden md:block md:absolute -bottom-11 -right-11 rotate-180" />
          </div>
        </div>
      </div>
    </header>
  )
}
